import solicitudes from './solicitudes.js';

export const getSucursalesbyEmmpresaSumm = async (id_usuario) => {
    const parametros = `/sucursales/info-summ/${id_usuario}`;
    try {

        const response = await solicitudes.fetchRegistrosAuth(parametros);

        if (response && Object.keys(response).length > 0) {

            return response; // Retorna el registro creado o la respuesta completa

        } else {
            throw new Error('No se hizo el get');
        }

    } catch (error) {
        console.error('Error en get registro:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

export const getDatosSucursal = async (id_usuario) => {
    try {    
              const sucursalDatos = await solicitudes.fetchRegistrosAuth(
                  `/sucursales/sucursal-datos/${id_usuario}`
                );

                return sucursalDatos;
        
            } catch (error) {
              console.log(error);
              throw 'Algo salio mal';
            }
};

export const sucursalSar = async (id_usuario) => {
    try {
        // CEO/Admin en caja: pasar id_sucursal override para evitar error 500
        // (el CEO tiene múltiples sucursales, el endpoint usaba .single() y fallaba)
        let url = `/sucursales/sucursal-sar/${id_usuario}`;
        try {
            const role = localStorage.getItem('role');
            if (role === '1' || role === '4') {
                const override = JSON.parse(localStorage.getItem('caja_sucursal_override') || 'null');
                if (override?.id_sucursal) url += `?id_sucursal=${override.id_sucursal}`;
            }
        } catch { /* sin override, usa endpoint normal */ }
        await solicitudes.fetchRegistrosAuth(url);
        return true;
    } catch {
        return false;
    }
}


export const postProducto = async (datos) => {
    const parametros = '/productos/crear';
    try {

        const response = await solicitudes.postRegistroAuth(parametros, datos);

    console.log(`Response: ${response}`);
        if (response && Object.keys(response).length > 0) {
            console.log(response);
            return response; // Retorna el registro creado o la respuesta completa
        } else {
            throw new Error('No se hizo el post');
        }

    } catch (error) {
        console.error('Error en postProducto:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

// const { codigo_producto, nombre, descripcion, precio_unitario, precio_mayorista, proveedor, unidad_medida, impuesto, id_usuario } = req.body;
//     const id_producto = req.params.id_producto;

export const patchProducto = async (datos, id_producto) => {
    console.log(datos);
    const parametros = `/productos/actualizar/${id_producto}`;
    try {

        const response = await solicitudes.patchRegistroAuth(parametros, datos);
        console.log(response);
        if (response && response == true) {

            return response; // Retorna el registro creado o la respuesta completa
        } else {
            throw new Error('No se hizo el patch');
        }

    } catch (error) {
        console.error('Error en patchProducto:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}

export const desactivarProducto = async (id_producto) => {
    const datos = {
        estado: false
    };
    const parametros = `/productos/desactivar/${id_producto}`;
    try {
        const response = await solicitudes.patchRegistroAuth(parametros, datos);
        console.log(response);
        if (response && response == true) {

            return response; // Retorna el registro creado o la respuesta completa
        } else {
            throw new Error('No se hizo el patch');
        }

    } catch (error) {
        console.error('Error en Producto:', error); // Registra el error para depuración
        throw error; // Opcional: vuelve a lanzar el error para manejarlo en otro lugar
    }
}
